module.exports = __webpack_public_path__ + "img/men.7b87ecda.svg";